var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"text-nowrap px-1",staticStyle:{"font-size":"smaller"}},[_vm._v(" "+_vm._s(_vm.data)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }